import dayjs from "dayjs";
import { reactive } from "vue";
import { useUserSettings } from "@services/UserSettings";
import { reloadMyGarageViewModel } from "@app/MyGarage/Types/MyGarageViewModelStore";
import { useRouter } from "@library/Services";

const DAYS_TO_SKIP = 3;

export const usePairingState = () => 
{
    if( HealthMonitorPairing.instance == null )
    {
        HealthMonitorPairing.instance = reactive( new HealthMonitorPairing() );
    }
    return HealthMonitorPairing.instance;
}

class HealthMonitorPairing
{

    isPairing: boolean = false;
    hasCheckedAgain: boolean = false;
    numberofPairingAttempts: number = 0;

    static instance: HealthMonitorPairing;

    constructor()
    {
        const settings = useUserSettings();
        this.isPairing = settings.isPairing;
        this.numberofPairingAttempts = Number( settings.numberOfPairingAttempts ?? 0 );
    }

    /**
     * Begins a pairing state as the user is navigated to the vehicle settings in Jupiter.
     * The delay is to allow the app to navigate to the Jupiter page before the webview updates,
     * otherwise the UI will show a warning that the device is not paired
     */
    public beginPairing( delay = 3000 )
    {
        setTimeout( () => {
            const settings = useUserSettings();
            this.isPairing = true;
            this.numberofPairingAttempts += 1;
            this.hasCheckedAgain = false;
            settings.isPairing = true;
            settings.numberOfPairingAttempts = this.numberofPairingAttempts;
        }, delay )
    }

    /**
     * Ends a pairing state.
     */
    public async endPairing()
    {
        
        const settings = useUserSettings();
        settings.isPairing = false;

        await reloadMyGarageViewModel();

        this.isPairing = false;
        this.hasCheckedAgain = false;

        const router = useRouter();
        router.go( '/my-garage' );
        
    }

    /**
     * Sets the flag to skip pairing for a period of time
     */
    public async skipPairing()
    {

        await this.endPairing();
        const settings = useUserSettings();
        settings.skipHealthMonitorReminderUntil = dayjs().add( DAYS_TO_SKIP, 'day' ).toISOString();

        const router = useRouter();
        router.go( '/my-garage' );

    }

    /**
     * Cancels the skipping of the health monitor connection
     */
    public cancelSkip()
    {
        const settings = useUserSettings();
        settings.skipHealthMonitorReminderUntil = null;
    }
    
}